import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        if (props.type && props.type == 'Newsletter') {
            this.state = {
                view: 2,
                label: 'general',
                displayTag: true,
            };
        } else if (props.lists) {
            const tarotSpecificMailList = props.lists
                .map(list => list.code)
                .filter(item => item != 'dh_dailyhoroscope' && item != 'number_of_the_day');

            const currentlySubscribedList = props.lists
                .map(list => list.subscribed ? list.code : null)
                .filter(item => item != null && item != 'dh_dailyhoroscope' && item != 'number_of_the_day');

            const shouldOfferLists = props.lists.filter(list => (
                !list.unsubscribed
                &&
                !list.subscribed
                &&
                list.code != 'dh_dailyhoroscope'
                &&
                list.code != 'number_of_the_day'
            ));

            const noWRSyesDHEDLE = !_.contains(currentlySubscribedList, 'weekly_love')
                && _.contains(currentlySubscribedList, 'dailyhoroscope')
                && _.contains(currentlySubscribedList, 'dle');

            let displayTag = tarotSpecificMailList != currentlySubscribedList;
            if (_.isEmpty(shouldOfferLists) || noWRSyesDHEDLE) {
                displayTag = false;
            }

            const label = (
                !_.contains(currentlySubscribedList, 'dle')
                &&
                _.contains(currentlySubscribedList, 'dailyhoroscope')
            )
                ? 'love'
                : 'general';

            this.state = {
                view: 1,
                displayTag: displayTag,
                label: label,
            };
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.submitting != this.props.submitting) {
            if (this.props.submitting) {
                this.setState({ ...this.state, view: 2 });
            }

            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        if (nextProps.dirty != this.props.dirty) {
            return true;
        }

        if (nextProps.lists != this.props.lists) {
            return true;
        }

        return false;
    }

    render() {
        if (this.state.displayTag) {
            return (
                <newsletter-subscribe>
                    <row className='is-justified-center has-margin-15-top'>
                        <column className='is-11 is-12-mobile'>
                            <form className='has-text-center'>
                                {this.renderLandingMessage()}
                                {this.renderButton()}
                                {this.renderErrorMessage()}
                            </form>
                        </column>
                    </row>
                </newsletter-subscribe>
            );
        }

        return (<newsletter-subscribe />);
    }

    renderLandingMessage = () => {
        if (this.state.view == 1) {
            return (
                <h4>
                    Get Your Free Daily {this.state.label === 'love' ? 'Love ' : ''}
                    <br className='is-visible-mobile' />
                    Horoscopes by Email!
                </h4>
            );
        }

        return (
            <h4>
                Success! Your {this.state.label === 'love' ? 'love ' : ''}
                horoscopes will now be sent directly to your email.
            </h4>
        );
    }

    renderButton = () => {
        let button_class = !this.props.submitting ? ' button button-pink-alternate' : 'button-warning disabled';
        let button_text = !this.props.submitting ? 'Sign Me Up!' : 'submitting...';

        if (this.state.view == 2) {
            button_class = 'button';
            button_text = this.state.label === 'love' ? "See Today's Love Horoscope" : "See Today's Horoscope";
        }

        return (
            <button
                type='button'
                className={`has-margin-5-top ${button_class}`}
                onClick={this.subscribeOrRoute}
                disabled={this.props.submitting}
            >
                {button_text}
            </button>
        );
    }

    renderErrorMessage = () => {
        if (this.props.error && !this.props.dirty) {
            return (
                <p className='is-error'>
                    Unable to save one or more of your preferences.
                    ({this.props.error})
                </p>
            );
        } else if (this.props.dirty && this.state.view === 1) {
            return (<p className='is-error'>You have already signed up.</p>);
        }

        return null;
    }

    subscribeOrRoute = () => {
        let label = this.state.label === 'love'
            ? "See Today's Horoscope Button - Love"
            : "See Today's Horoscope Button";

        if (this.state.view === 1) {
            label = this.state.label === 'love' ? 'Sign Me Up Button - Love' : 'Sign Me Up Button';
        }

        if (!this.props.submitting && this.state.view == 1) {
            const subscribeToObject = this.props.lists.map(list => {
                if (
                    !list.subscribed
                    &&
                    !list.unsubscribed
                    &&
                    list.code != 'dh_dailyhoroscope'
                    &&
                    list.code != 'number_of_the_day'
                ) {
                    list.intent = true;
                }

                return list;
            });

            this.props.updateLists({
                lists: subscribeToObject,
                dirty: false,
            });

            this.props.saveLists({ location: 'newsletter-module' });
        }

        this.props.trackEvent(['Newsletter Subscribe', 'LI Click', label]);

        if (this.state.view == 2) {
            this.props.updateLists({ dirty: true });
            const route = this.state.label !== 'love' ? '/daily-horoscope' : '/daily-love-horoscope';
            window.location.href = route;
        }
    }
}

const mapStateToProps = (state) => ({
    submitting: state['mail-lists'] && state['mail-lists'].submitting,
    lists: state['mail-lists'] && state['mail-lists'].lists,
    error: state['mail-lists'] && state['mail-lists'].error,
    dirty: state['mail-lists'] && state['mail-lists'].dirty,
    type: state['mail-lists'] && state['mail-lists'].type,
});

const mapDispatchToProps = (dispatch) => ({
    saveLists: (payload) => dispatch({
        type: 'mail-lists:save',
        payload: payload,
    }),
    updateLists: (payload) => dispatch({
        type: 'mail-lists:update',
        payload: payload,
    }),
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);